var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxBoldCpuSetting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 9zm.09 6.92zM9 20zM9 4zm6 0zm5 5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.25 9.05H20v1.837a.432.432 0 0 1-.65.373c-.43-.25-.93-.33-1.41-.2-.25.06-.48.17-.68.31V9.74c0-1.65-1.35-3-3-3H9.74c-1.65 0-3 1.35-3 3v4.52c0 1.65 1.35 3 3 3h.45a.21.21 0 0 1 .21.21c0 1.1.91 2 2.02 2-.1.16-.17.35-.22.53H9.06v1.25a.749.749 0 1 1-1.5 0v-1.47a5.004 5.004 0 0 1-3.33-3.33H2.75a.749.749 0 1 1 0-1.5H4v-2.2H2.75a.749.749 0 1 1 0-1.5H4v-2.2H2.75a.749.749 0 1 1 0-1.5h1.48a5.004 5.004 0 0 1 3.33-3.33V2.75a.749.749 0 1 1 1.5 0V4h2.19V2.75c0-.41.34-.75.75-.75s.75.34.75.75V4h2.2V2.75c0-.41.34-.75.75-.75s.75.34.75.75v1.48c1.59.48 2.84 1.73 3.32 3.32h1.48c.42 0 .75.34.75.75 0 .42-.33.75-.75.75z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.92 14.691c0-.2.06-.43.2-.67a1 1 0 0 0-.37-1.37l-.91-.53a.885.885 0 0 0-1.21.32l-.06.1c-.48.83-1.26.83-1.74 0l-.06-.1a.873.873 0 0 0-1.2-.32l-.92.53c-.32.18-.51.52-.51.87 0 .17.05.34.14.5.14.24.21.47.21.67 0 .5-.4.84-1.08.84-.55 0-1.01.45-1.01 1v.94c0 .55.46 1 1.01 1 .68 0 1.08.34 1.08.84 0 .2-.07.43-.21.67a1 1 0 0 0 .37 1.37l.92.53c.41.25.96.1 1.2-.32l.06-.1c.48-.83 1.26-.83 1.74 0l.06.1c.25.42.79.57 1.21.32l.91-.53c.32-.18.51-.52.51-.87 0-.17-.05-.34-.14-.5-.14-.24-.2-.47-.2-.67 0-.5.39-.84 1.07-.84.56 0 1.01-.45 1.01-1v-.94c0-.55-.45-1-1.01-1-.68 0-1.07-.34-1.07-.84zm-4.94 2.31a1.72 1.72 0 1 1 3.44 0 1.72 1.72 0 0 1-3.44 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.58 11.09a1.808 1.808 0 0 0-1.51.16l-.91.53c-.63.35-1.02 1.02-1.02 1.74 0 .34.08.69.27 1.01-1.01 0-1.85.75-1.99 1.72h-.4c-1.26 0-2.27-1.01-2.27-2.27v-3.96c0-1.26 1.01-2.27 2.27-2.27h3.96c1.26 0 2.27 1.01 2.27 2.27v.6a.5.5 0 0 1-.67.47z",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldCpuSetting);
export default __webpack_public_path__ + "static/media/vuesax-bold-cpu-setting.a03f47350d38bf1b434eba0c539ff979.svg";
export { ForwardRef as ReactComponent };